import React from "react";
import IconHeading from "../../../Icons/IconHeading";
import IconMinus from "../../../Icons/IconMinus";
import IconPlus from "../../../Icons/IconPlus";
import moneyFormat from "../../MoneyFormat/moneyFormat";
import {INBOUND, OUTWARD, RETURN_TRIP} from "../../consts/bookingConsts";
import dataLayerHandler, {TRIP_EXTRA, TRIP_RETURN_EXTRA} from "../../dataLayer/dataLayerHandler";

const ExtraRequirements = (props) => {

  const {
    bookingType,
    outbound,
    inbound,
    setOutbound,
    setInbound
  } = props;

  if ((!inbound || inbound.extras.length === 0) && (!outbound && outbound.extras.length === 0)) {
    return null;
  }

  const handleUp = (trip, index, setFunction, extra, type) => {
    let val = trip.extras[index].quantity + 1;
    handleChange(trip, index, val, setFunction, extra, type)
  }

  const handleDown = (trip, index, setFunction, extra, type) => {
    let val = trip.extras[index].quantity;
    if (val >= 1) {
      val -= 1;
    }
    handleChange(trip, index, val, setFunction, extra, type)
  }

  const handleChange = (trip, index, value, setFunction, extra, type) => {
    if (value < 0) {
      value = 0;
    }
    const t = {...trip};
    t.extras[index].quantity = value;
    setFunction(t);


    dataLayerHandler(type === OUTWARD ? TRIP_EXTRA : TRIP_RETURN_EXTRA, {
      extra: extra.name,
      quantity: value
    });
  }
  return <div className="booking__section">
    <div className="booking__luggage">
      <div className="booking__title">
        <div className="booking__headIcon">
          <IconHeading />
        </div>
        <h3>Luggage Requirements</h3>
      </div>
      {<div>
        <p>
          Included with your booking is one standard-size suitcase and one small carry-on suitcase.
          If you have extra or oversized luggage, please indicate this as below.<br />
          <i>
            Please note that failure to declare additional or oversized luggage may result in our team
            being unable to transport your belongings.
          </i>
        </p>
      </div>}
    </div>
    <div className="booking__luggage__content">

      {(outbound && outbound.extras.length > 0) && <>
        <div className="booking__luggage__sub">
          <div className="booking__luggage__subTitle">
            <label className="h4">Departing Trip</label>
          </div>
          {outbound.extras.map((extra, index) => {
            return <div
              key={index}
              className="booking__luggage__item">
              <div className="booking__luggage__itemWrap">
                <div className="item__left">
                  <label className="h5">{extra.name}</label>
                  {!!extra.description && <p>{extra.description}</p>}
                </div>
                <div className="item__right">
                  <div className="item__counter">
                    <div
                      className="item__reduce item__action"
                      onClick={() => {
                        handleDown(outbound, index, setOutbound, extra, OUTWARD);
                      }}>
                      <IconMinus />
                    </div>
                    <div className="item__count">
                      <input
                        type="number"
                        aria-labelledby="quantity"
                        value={extra.quantity}
                        onChange={(e) => {
                          handleChange(outbound, index, value, setOutbound, extra, OUTWARD);
                        }}
                      />
                    </div>
                    <div
                      className="item__increase item__action"
                      onClick={() => {
                        handleUp(outbound, index, setOutbound, extra, OUTWARD);
                      }}>
                      <IconPlus />
                    </div>
                  </div>
                  <div className="item__price">
                    <p className="h4">{moneyFormat(extra.price)}</p>
                  </div>
                </div>
              </div>
            </div>
          })}
        </div>
      </>}


      {(bookingType === RETURN_TRIP && inbound && inbound.extras.length > 0) && <>
        <div className="booking__luggage__sub">
          <div className="booking__luggage__subTitle booking__luggage__subTitle--return">
            <label className="h4">Return Trip</label>
          </div>

          {inbound.extras.map((extra, index) => {
            return <div
              key={index}
              className="booking__luggage__item">
              <div className="booking__luggage__itemWrap">
                <div className="item__left">
                  <label className="h5">{extra.name}</label>
                  {!!extra.description && <p>{extra.description}</p>}
                </div>
                <div className="item__right">
                  <div className="item__counter">
                    <div
                      className="item__reduce item__action"
                      onClick={() => {
                        handleDown(inbound, index, setInbound, extra, INBOUND)
                      }}>
                      <IconMinus />
                    </div>
                    <div className="item__count">
                      <input
                        type="number"
                        aria-labelledby="item__count"
                        value={extra.quantity}
                        onChange={(e) => {
                          handleChange(inbound, index, value, setInbound, extra, INBOUND)
                        }}
                      />
                    </div>
                    <div
                      className="item__increase item__action"
                      onClick={() => {
                        handleUp(inbound, index, setInbound, extra, INBOUND)
                      }}>
                      <IconPlus />
                    </div>
                  </div>
                  <div className="item__price">
                    <p className="h4">{moneyFormat(extra.quantity ? extra.price * extra.quantity : extra.price)}</p>
                  </div>
                </div>
              </div>
            </div>
          })}

        </div>
      </>}



    </div>
  </div>

}

export default ExtraRequirements;
